import { Team } from '@graphql/generated';
export const getTeamStatus = (
  team?: Team
): 'Team' | 'team-trial' | 'team-expired' | 'basic' | 'cancelled' => {
  // Guard subscriptionDetails on every access — it can be undefined while the
  // getTeamBilling query is still loading (TA-9872). Without the optional chain
  // these dereferences would throw if the || short-circuit order ever changed.
  const hasPaymentMethod =
    team?.subscriptionDetails?.paymentCardLast4 !== '' ||
    team?.subscriptionDetails?.paymentCardLast4 !== null ||
    team?.subscriptionDetails?.paymentCardLast4 !== undefined;
  const trialDate = team?.subscriptionDetails?.trialEndsAt;

  const now = new Date();
  if (team?.personal) return 'basic'; //personal team (1)

  if (team?.subscriptionDetails?.isSubscriptionOnTrial) {
    if (trialDate && new Date(trialDate) < now) {
      if (hasPaymentMethod)
        return 'Team'; // trail ends and has payment method (4)
      else if (!hasPaymentMethod) return 'team-expired'; // trial ends and no payment method (3)
    } else if (
      team?.subscriptionDetails?.isSubscriptionOnTrial &&
      trialDate &&
      new Date(trialDate) >= now
    ) {
      return 'team-trial'; //trial is active (1) (2)
    }
  }
  if (team?.subscriptionDetails?.isSubscriptionActive) {
    if (team?.subscriptionDetails?.isSubscriptionCanceled) return 'cancelled';
    if (hasPaymentMethod) return 'Team'; // user is being billed (1)
    if (hasPaymentMethod && team?.subscriptionDetails?.isSubscriptionCanceled)
      return 'Team'; // user is being billed but has canceled subscription (2)
    if (
      team?.subscriptionDetails?.isSubscriptionCanceled ||
      (team?.subscriptionDetails?.subscriptionStatus !== 'canceled' &&
        !hasPaymentMethod)
    )
      return 'team-expired'; // plan expired and no payment method (3)
  }

  if (
    team?.subscriptionDetails?.isSubscriptionCanceled &&
    !team?.subscriptionDetails?.isSubscriptionOnTrial &&
    !team?.subscriptionDetails?.isSubscriptionActive
  )
    return 'team-expired'; // canceled subscription
  return 'basic';
};
